import React, { useState, useEffect, useContext } from 'react';
import { RiMapPinLine, RiArrowDownSLine, RiArrowUpSLine}
from 'react-icons/ri';
// importing headless ui
import { Menu } from '@headlessui/react';
// importing house context
import { HouseContext } from './HouseContext';

const CountryDropdown = () => {
  const { country, setCountry, countries } =
  useContext(HouseContext);


  const [isOpen, setIsOpen] = useState(false);

  return (
    <Menu as='div' className='dropdown relative'>
      <Menu.Button onClick={() => setIsOpen(!isOpen)}
      className='dropdown-btn w-full text-left'>
        <RiMapPinLine
        className='dropdown-icon-primary' />
        <div>
          <div className='text-[15px] font-medium leading
          -tight'>{country}</div>
          <div className='text-[13px]'>Select your city</div>
          {isOpen ? (
            <RiArrowUpSLine className='dropdown-icon-secondary' />
          ) : (
            <RiArrowDownSLine className='dropdown-icon-secondary' />
          )}
        </div>
      </Menu.Button>

     <Menu.Items className='dropdown-menu'>
      {countries.map((country, index) => {
        return (
          <Menu.Item
          onClick={() => setCountry(country)}
          className='cursor-pointer hover:text-orange-700 
          transition' as='li'
          key={index}>
            {country}
          </Menu.Item>
        );
      })}
     </Menu.Items>
    </Menu>
  );
 
};

export default CountryDropdown;
